import React ,{useState,useEffect,useRef} from 'react';
import { RiSendPlane2Fill} from "react-icons/ri";

export default function Pestania  (props) {

  console.log("desde pestania"+props);

  const [state,setState] = useState(true);

  const changeState = () => {
    alert(props.id);
  }

  return(
  <>
    <div className={`${
      props.active ? 
      'divide-y items-self-end text-center p-3 w-full bg-primary text-white font-semibold':
      'divide-y items-self-end text-center p-3 w-full bg-gray-200 text-fondo hover:bg-gray-100'
    } cursor-pointer`} style={{
      width: '100%',
    }}
    onClick={()=>{props.onPress()}}
    >
      {props.nombre}
    </div>
  </>
  );
};